import { Injectable } from '@angular/core';
import { Statistics } from 'app/trello/models/board-summary';
import { MemberChartData } from 'app/trello/models/charts';
import { StatisticsAggregator } from 'app/trello/utility/statistics-aggregator';
import { StructureTransformer } from 'app/trello/utility/structure-transformer';

@Injectable({
  providedIn: 'root'
})
export class MemberChartDataAggregator {

  constructor(
    private readonly statisticsAggregator: StatisticsAggregator,
    private readonly statisticsTransformer: StructureTransformer,
  ) {
  }

  public aggregate(
    stats: Statistics,
    aggregationLevel: 'day' | 'week' | 'month' = 'day'
  ): MemberChartData {

    const totalMemberCardsData =
      this.statisticsAggregator.aggregateCountDistinct(
        stats.member.total.day || {},
        aggregationLevel,
      );

    const memberAssignedData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.member.assigned) || {},
        aggregationLevel,
      );

    const memberUnassignedData =
      this.statisticsAggregator.aggregateCountDistinct(
        this.statisticsTransformer.mergeInnerArrays2D(stats.member.unassigned) || {},
        aggregationLevel,
      );

    const memberDurationData =
      this.statisticsAggregator.aggregateDuration(
        this.statisticsTransformer.collectInnerValues2D(stats.member.duration) || {},
        aggregationLevel,
      );

    return {
      totalCards: totalMemberCardsData,
      assigned: memberAssignedData,
      unassigned: memberUnassignedData,
      duration: memberDurationData,
    };
  }

}
